/* Omnify: levertekst in de cart wisselt om 20:00 (Nederlandse tijd) */
if (!customElements.get('omnify-ship-time')) {
  customElements.define('omnify-ship-time', class extends HTMLElement {
    connectedCallback() {
      var hour = 0;
      try {
        hour = parseInt(new Intl.DateTimeFormat('nl-NL', { hour: 'numeric', hour12: false, timeZone: 'Europe/Amsterdam' }).format(new Date()), 10);
      } catch (e) { hour = new Date().getHours(); }
      var after = hour >= 20;
      var b = this.querySelector('[data-before]'), a = this.querySelector('[data-after]');
      if (b) b.hidden = after;
      if (a) a.hidden = !after;
    }
  });
}
